const doc = [({"da":({"js":({"teams":({"selector":({"choose_team":({"individual":"Individuelt", "join_team":"Hop på et hold"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;